import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import AuctionCarousel, {
  AUCTION_CAROUSEL_TYPE,
  imgBreakpoints,
} from "../../auctions/auction-carousel/auction-carousel.component";
import {
  CMHeadingContainer,
  CMDetails,
  CMCarouselContainer,
  CMAuctionDescription,
  CMBox,
  CMOffer,
  CMDisclaimer,
  CMDisBox,
} from "./confirm-bid.styles";

import { bid_Add, getAuctionDetails } from "../../../Services/auction.service";
import { useAuth } from "../../../Contexts/auth.context";
import Cookies from 'js-cookie';
import { CMError } from "../make-offer/make-offer.styles";

const ConfirmBid = ({ handleNext, handlePrev,values,auction,setAuction,setActiveStep ,setRefreshDetailsPage,refreshDetailsPage,balanceFee,setBalanceFeeFormatted,setWarningMessage}) => {
  const [loading, setLoading] = useState(false);
  const {auth} = useAuth();
  const [pending, setPending] = useState(false);
  const [ unitError, setUnitError ] = useState('');

  const totalBidString = values?.totalBid || "$0";
  const totalBidStringClear = totalBidString.replace(/[$,]/g, '');
  const totalBidValue = parseFloat(totalBidStringClear) || 0;
  const totalBidWithFee = totalBidValue * ((balanceFee / 100)); 
  const totalSum = totalBidValue + totalBidWithFee;
  const balanceFeeFormatted = parseFloat(totalSum)?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  setBalanceFeeFormatted(balanceFeeFormatted);

  const handleConfirm = async () => {
    setLoading(true);
    setPending(true);
   if(auth && auth.userId) {
        const referrer = Cookies.get('referrer');
        const newValues = {
          ...values,
          feePercetage:balanceFee,
          feeAmount:totalBidWithFee,
          totalBid:totalSum,
          referrer: referrer,
        };
        bid_Add(auth.userId,auction.auctionID,auth.idToken, auth.sessionId, newValues).then(data => {
          // When click make an offer to go to  Confirm Bid  Screen
        if(data.status !== "Winner" && data.status !== "Loss"){          
          setUnitError( data.message );
          //setWarningMessage(data.message)
          //setActiveStep(8);
          return ; 
        }
        setActiveStep((value) => value + 1);
        if(data && data.ended==1) {
          //setValues({...values, ...data});*/
          //auction.status="finished";
          //setAuction(old=>old.status='finished');
          setAuction(old => ({
            ...old,
            status:'finished'
          }))
          setRefreshDetailsPage(old=>!old);
        } else {
          setRefreshDetailsPage(old=>!old);
        }
        
      }).catch((err) => {
        console.error('There was an error saving the information.');
      }).finally(() => {
        setLoading(false);
      } );
    } else {
      console.error('User not authorized.')
    }
  };
 
  return (
    <>
      <CMHeadingContainer>
        <h3>
          Auction symbol / <span>{auction.symbol}</span>{" "}
        </h3>
      </CMHeadingContainer>
      <CMDetails className="dotted-border">
        <CMCarouselContainer>
          <AuctionCarousel
            slides={auction.imgSrc}
            carouselType={AUCTION_CAROUSEL_TYPE.imageSemiRounded}
            breakpoints={imgBreakpoints}
            auctionID={auction.auctionID}
          />
        </CMCarouselContainer>
        <CMAuctionDescription>
        <h3>{auction.assetName}</h3>
        </CMAuctionDescription>
      </CMDetails>

      <CMBox>
        <div className="table-container">
          <div className="column1">
            <h5>Bid per unit</h5>
            <h3>${values.bidPerUnit}</h3>
          </div>
          <div className="column2">
            <h5>Number of units</h5>
            <h3>{values.totalUnit}</h3>
          </div>
          <div className="column3">
            <h5>Total bid amount</h5>
            <h3>{balanceFeeFormatted}</h3>
          </div>
        </div>
      </CMBox>

      <CMDisBox>
        <h3>Disclaimer</h3>
        <CMDisclaimer>
          <p>
            Before investing in music royalties, it's important to understand
            that the income generated from music royalties can be unpredictable
            and may fluctuate over time. The amount of royalties received is
            dependent on various factors such as the popularity of the music,
            the number of streams or sales, and the terms of the licensing
            agreements. Additionally, the music industry is constantly evolving
            and there is no guarantee that a particular song or artist will
            continue to generate substantial royalties in the future.
          </p>
          <p>
            Investing in music royalties carries a level of risk, and it's
            important to carefully research and consider all aspects of the
            investment before making a decision. It's recommended that you seek
            advice from a financial professional and/or legal counsel to fully
            understand the potential risks and benefits associated with
            investing in music royalties. By investing in music royalties, you
            acknowledge and accept these risks and limitations.
          </p>
        </CMDisclaimer>
      </CMDisBox>

      <CMOffer>
        <Button
          buttonType={BUTTON_TYPE_CLASSES.TextButton}
          color="blue"
          onClick={handlePrev}
          className="txtButtonStyle"
        >
          &lt; Edit Order
        </Button>
        <Button  isProgressButton={true} loading={loading}  onClick={handleConfirm} color="light-green" disabled={pending}> 
          Confirm Bid
        </Button>
      </CMOffer>
        <CMError fontSize="18px" centered>
        { unitError }
      </CMError>
    </>
  );
};
export default ConfirmBid;
